export default __webpack_public_path__ + "static/media/chat-app.74f6f0e8.PNG";